function productcarousel(){
  $(document).on('click','.daily-h-list li a,.daily-h-listmob a',function(e){
    e.preventDefault();
    var data_url = $(this).data('url');
    var data_title = $(this).data('title');
    $('[data-title="'+data_title+'"]').closest('li').hide().siblings('li').show();
    $(this).closest('.daily-header').find('.daily-h-title').text(data_title);
    $(this).closest('.daily-h-dropdown').find('.daily-h-list').slideUp();
    $(this).closest('.daily-h-dropdown').removeClass('active');
    var collection_grid = $(this).closest('.section-product-carousel').find('.carousel-rowouter').data('desktopgrid');
    var collectionlimit = $(this).closest('.section-product-carousel').find('.carousel-rowouter').data('limit');
    $('.mob-pcarousel-button a').attr('href',data_url);
    $('.mob-pcarouseltext').text(data_title);
    $.ajax({
      url: data_url + "?view=json",
      dataType: "html",
      success: function (collection) {
        var collectiondata = JSON.parse(collection);
        var product = collectiondata.product;
       
        var productlen = product.length;
        if(productlen>collectionlimit){
          var final_arry = collectionlimit;
        }else{
          var final_arry = productlen;
        }
        $('.rowsection').html('');
        function carouselloop(i){
        return `
		<div class="procarousel-col">
          <div class="snippet-product-grid"> 
              <div class="grid-imagebox">
                  
				  <div class="product-images">
				  <div class="normal-img">
                  <a href="${product[i].url}" class="product-link"><img src="${product[i].thumbnail}" loading="lazy" class="front-img"/>
				  <img src="${product[i].rear}" loading="lazy" class="rear-img"/></a>
				  </div>
				  </div>
      <div class="var_div">
       <ul class="size_grid">
       
       ${
        (function myfunction() {
            let pdp2 = product[i].size;
          let test = '';
          let count = 0;
            for (let name in pdp2) {
           if(count > 3){
            test  += `<li><a href="${product[i].url}">..</a></li>`
             break;
           }
              else{
              test  +=`
                <li data-id="${pdp2[name]}">
                          <a
                          href="javascript:void(0)"">${name}</a>                     
						</li>` 
                }
              count++;
                
            }
         
          return test ; 
        })()
        }
        
       </ul>
       <div class="quickviewbtn-wrapper">
        <a href="#" class="quickviewbtn" data-handle="${product[i].handle}" data-title="">
        <span class="d-none d-lg-block">Quick view</span>
        <span class="d-block d-lg-none">
        <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="5.34314" width="18.2598" height="17.3616" rx="2.25" stroke="white" stroke-width="1.5"></rect>
        <path d="M15.2688 4.59269V4C15.2688 2.34314 13.9257 1 12.2688 1H7.49078C5.83393 1 4.49078 2.34314 4.49078 4V4.59269" stroke="white" stroke-width="1.5"></path>
        </svg>
        </span>
        </a>
        </div>
      </div>
                  
              </div>
              <div class="grid-meta">
                  <div>
                      <h5><a href="${product[i].url}">${product[i].title}</a></h5>
                      <p>${product[i].price}</p>
                  </div>
                  <ul class="grid-colorlist">
					${product[i].color.map(colors => 
                      (Object.entries(colors).length !== 0) ? `<li>
                        <a href="/product/${colors.productname}" style="border:1px solid ${colors.colorborder};">
                          <span class="colorimggrid" style="background-color:${colors.colorcode};background-image:url(${colors.colorimage});"></span>
                        </a>
						</li>` : null                      
        			).join('')}
                  </ul>
              </div>
          </div>
		</div>
		`
        }
        var new_carousel = '';
        new_carousel += '<div class="carousel-row firstspace product-carousel flickit-before" data-id="'+$(this).closest('.rowsection').data('id')+'" data-loop="false">'
        for(i=0;i<final_arry;i++){
          new_carousel += carouselloop(i);
        }
        new_carousel += '</div>';
        $('.rowsection').html(new_carousel);
        function flickityScroll(thisData){
          var flktycarousel = thisData.data('flickity');
          var lastCell = false,firstCell=false;
          flktycarousel.on('cellSelect', function(){
            var friction = (flktycarousel.options['friction'] + 0.1) * 1000;
            setTimeout(function(){
              var fullSize = flktycarousel.slideableWidth,
                  viewport = flktycarousel.size['width'],
                  cellWidth = flktycarousel.selectedSlide['outerWidth'],
                  movedX = Math.round(flktycarousel.x);
              fullSize = Math.round(fullSize);
              cellWidth = Math.round(cellWidth);
              movedX = Math.abs(movedX);
              var total = Math.round((viewport + movedX) / 100) * 100,
                  fullSize = Math.round(fullSize / 100) * 100;
              thisData.find('.flickity-prev-next-button.next').prop('disabled', false);
              if(total >= fullSize){
                if(lastCell == true)
                  //flktycarousel.select(0);
                  lastCell = true;
                if(lastCell == true){
                  thisData.find('.flickity-prev-next-button.next').prop('disabled', true);                  
                }
                thisData.addClass('lastspace');
                thisData.find('.flickity-prev-next-button.next').prop('disabled', true);
              }else{
                thisData.removeClass('lastspace');
              }
              firstCell=false;
              thisData.removeClass('firstspace');
              if(movedX < 70){
                lastCell = false;
                firstCell = true;
                thisData.addClass('firstspace');       
              }
            }, friction);
          });
        }
        $('.product-carousel').each(function(e){
          var thisslider = $(this);
          $(this).flickity({pageDots: false,cellAlign:"left",contain:true});
          flickityScroll(thisslider);
        });
      }
    });
  });
  $(document).on('click','.daily-h-button,.daily-h-listmob .daily-h-title',function(e){
    e.preventDefault();
    $(this).closest('.daily-h-dropdown').find('.daily-h-list').slideToggle();
    $(this).closest('.daily-h-dropdown').toggleClass('active');
  });
  $('body').on('click',function(e){   
    var seachbox = $(".daily-h-dropdown");    
    if (!seachbox.is(e.target) && seachbox.has(e.target).length === 0){
      $(".daily-h-dropdown").removeClass('active'); 
      $('.daily-h-list').hide();
    }
  });
}
productcarousel();